module.exports = {
    test:'TEST'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js